import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";

const BG   = "#fcfcfc";
const DARK = "#353841";
const MID  = "#C8B8A9";

const AdminUpiApprovals = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/api";

  const fetchPending = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_BASE_URL}/upi-payments/pending`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setItems(res.data.items || []);
    } catch (e) {
      // eslint-disable-next-line
    } finally {
      setLoading(false);
    }
  }, [API_BASE_URL]);

  useEffect(() => {
    fetchPending();
  }, [fetchPending]);

  const act = async (id, action) => {
    const token = localStorage.getItem("token");
    await axios.post(`${API_BASE_URL}/upi-payments/${id}/${action}`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    fetchPending();
  };

  if (loading) return <div className="p-6" style={{ color: MID }}>Loading...</div>;

  return (
    <div className="min-h-screen pt-32 sm:pt-28 md:pt-24 lg:pt-20" style={{ backgroundColor: BG }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-xl font-bold mb-4" style={{ color: DARK }}>Approve Payments</h1>
        <div className="rounded-lg shadow border" style={{ backgroundColor: BG, borderColor: MID }}>
          <div className="grid grid-cols-6 gap-2 p-3 text-xs font-semibold border-b" style={{ borderColor: MID, color: DARK }}>
            <div>Name</div><div>Email</div><div>Phone</div><div>Course</div><div>UTR</div><div>Action</div>
          </div>
          {items.length === 0 ? (
            <div className="p-6 text-sm" style={{ color: MID }}>No pending payments.</div>
          ) : (
            items.map((p) => (
              <div key={p._id} className="grid grid-cols-6 gap-2 p-3 text-sm border-b items-center" style={{ borderColor: MID, color: DARK }}>
                <div>{p.name}</div>
                <div className="truncate">{p.email}</div>
                <div>{p.phone}</div>
                <div>{p.courseTitle}</div>
                <div className="font-mono text-xs">{p.utrNumber}</div>
                <div className="space-x-2">
                  <button onClick={() => act(p._id, "approve")}
                    className="px-3 py-1 rounded text-xs"
                    style={{ backgroundColor: DARK, color: BG }}>Approve</button>
                  <button onClick={() => act(p._id, "reject")}
                    className="px-3 py-1 rounded text-xs"
                    style={{ backgroundColor: MID, color: DARK }}>Reject</button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminUpiApprovals;


